module.exports = __webpack_public_path__ + "img/qr-code.8264fa1f.png";